import { ApplicationConfig, APP_INITIALIZER } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { TokenInterceptor } from '@shared/interceptors/authorization.interceptor';
import { TokensInterceptor } from '@shared/interceptors/token.interceptor';
import { DialogService } from 'primeng/dynamicdialog';
import { PublicTokenInterceptor } from '@shared/interceptors/public-token.interceptor';
import { environment } from '@environments/environment';
import { initializeApp, getApps } from 'firebase/app';
import { getPerformance } from 'firebase/performance';

export function initFirebasePerformance() {
	return () => {
		try {
			if (typeof window !== 'undefined' && environment.FIREBASE_CONFIG?.apiKey) {
				const app = getApps().length === 0 ? initializeApp(environment.FIREBASE_CONFIG) : getApps()[0];
				getPerformance(app);
			}
		} catch (error) {
			console.warn('Firebase Performance initialization skipped or blocked:', error);
		}
	};
}

export const appConfig: ApplicationConfig = {
	providers: [
		DialogService,
		provideRouter(routes),
		provideAnimations(),
		provideHttpClient(withInterceptors([TokenInterceptor, TokensInterceptor, PublicTokenInterceptor])),
		{
			provide: APP_INITIALIZER,
			useFactory: initFirebasePerformance,
			multi: true,
		},
	]
};

